import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JANUARY_2026_CAMPAIGN_END_DATE = d(2026, 2, 28, 12, 0);
